// App.jsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Home from './Home';
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import WhyClean from './WhyClean';
import ClientReviews from './ClientReviews';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/services" element={<WhyClean />} />
        </Routes>
        <ClientReviews/>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
